// Client-side mirror of the backend PLAN_LIMITS dict. Used only for hiding/showing UI
// (the backend always enforces real limits — never trust the frontend).
//
// Keep these objects in sync with /app/backend/server.py PLAN_LIMITS + ADMIN_UNLIMITED.

export const PLAN_LABELS = {
  free: "Free Check",
  starter: "Starter",
  growth: "Growth",
  pro: "Pro",
  assist: "uSeen Assist",
  admin: "Admin",
};

export const PLAN_LIMITS_FALLBACK = {
  free: {
    max_businesses: 1, monthly_content: 1, monthly_rescan: 0,
    monthly_ai_questions: 1, max_analyses_per_business: 1,
    competitors: false, full_tasks: false, full_report: false,
    tasks_visible: 1, ai_questions_visible: 1, intents_visible: 2,
  },
  starter: {
    max_businesses: 1, monthly_content: 5, monthly_rescan: 3,
    monthly_ai_questions: 10, max_analyses_per_business: 99,
    competitors: false, full_tasks: true, full_report: false,
    tasks_visible: -1, ai_questions_visible: -1, intents_visible: -1,
  },
  growth: {
    max_businesses: 1, monthly_content: 30, monthly_rescan: 10,
    monthly_ai_questions: 30, max_analyses_per_business: 99,
    competitors: true, full_tasks: true, full_report: true,
    tasks_visible: -1, ai_questions_visible: -1, intents_visible: -1,
  },
  pro: {
    max_businesses: 3, monthly_content: 100, monthly_rescan: 25,
    monthly_ai_questions: 100, max_analyses_per_business: 99,
    competitors: true, full_tasks: true, full_report: true,
    tasks_visible: -1, ai_questions_visible: -1, intents_visible: -1,
  },
  assist: {
    max_businesses: 999, monthly_content: 999, monthly_rescan: 999,
    monthly_ai_questions: 999, max_analyses_per_business: 999,
    competitors: true, full_tasks: true, full_report: true,
    tasks_visible: -1, ai_questions_visible: -1, intents_visible: -1,
  },
  admin: {
    max_businesses: 9999, monthly_content: 9999, monthly_rescan: 9999,
    monthly_ai_questions: 9999, max_analyses_per_business: 9999,
    competitors: true, full_tasks: true, full_report: true,
    tasks_visible: -1, ai_questions_visible: -1, intents_visible: -1,
  },
};

export function limitsFor(user) {
  // Prefer the limits the server returned on /auth/me (single source of truth).
  if (user?.limits) return user.limits;
  const plan = user?.plan || "free";
  return PLAN_LIMITS_FALLBACK[plan] || PLAN_LIMITS_FALLBACK.free;
}

export function isUnlimited(user) {
  return user?.plan === "admin" || user?.plan === "assist";
}

export function planLabel(plan) {
  return PLAN_LABELS[plan] || plan || "Free Check";
}
